import services from '../views/Orders/services';
import { getCurrentUTCTimestamp } from './dateResolvers';
import { OrderMetaInfo } from '../views/Orders/orderUtils';

export default async function updateOrderHandlerAllocationTime(
  orderId: string,
  setOrderMetaInfoWithOrderId: (orderId: string, metaInfo: OrderMetaInfo) => void
) {
  try {
    const orderHandlerAllocationTime = getCurrentUTCTimestamp();
    await services.updateOrderMetaInfo(orderId, {
      orderHandlerAllocationTime,
    });
    
    setOrderMetaInfoWithOrderId(orderId, {
      orderHandlerAllocationTime,
    });
    
    return orderHandlerAllocationTime;
  } catch (error) {
    console.error("Failed to update order handler allocation time:", error);
    throw error;
  }
} 